import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  Campaign,
  CreateCampaignBody,
  UpdateCampaignBody,
} from '../model/Campaign';

@Injectable()
export class CampaignApi {
  protected basePath = `${environment.API_V4}/admin/campaigns`;

  constructor(protected http: HttpClient) {}

  public find(filter?: string) {
    let params = new HttpParams();
    if (filter) {
      params = params.set('filter', filter);
    }
    return this.http.get<Campaign[]>(this.basePath, {
      params,
    });
  }

  public getById(id: string) {
    return this.http.get<Campaign>(`${this.basePath}/${id}`);
  }

  public create(data: CreateCampaignBody) {
    return this.http.post<Campaign>(this.basePath, data);
  }

  public patch(id: string, data: UpdateCampaignBody) {
    return this.http.patch<void>(`${this.basePath}/${id}`, data);
  }

  public delete(id: string) {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }
}
